import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Language } from '../../../libs/system/model/language';

export const SettingsActions = createActionGroup({
  source: 'Settings',
  events: {
    'Load Settings': emptyProps(),
    'Load Language': props<{ languageCode: string }>(),
    'Set Language': props<{ language: Language }>(),
    'Load Theme': props<{ themes: Array<string> }>(),
    'Apply Theme': props<{ theme: string }>(),
    'Load mini Side Nav': emptyProps(),
    'Mini Side Nav Flag': props<{ mini: boolean }>(),
    'Network Status Flag': props<{ online: boolean }>(),
    'Set Page Size': props<{ pageSize: number }>(),
  },
});
